import {makeAuthRequest} from '../makeApiRequest'

const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_MERGER_SERVICE_API || 'api/merger'

export const getBasketInformation = (basketId) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}`,
        method: 'GET'
    })
}

export const getListBaskets = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/search`,
        method: 'POST',
        data: payload
    })
}

export const addOrderToBasket = (barcode, fac = '1C') => {
    return apiRequest({
        url: `${prefix}/items/${barcode}/${fac}`,
        method: 'POST'
    })
}

export const releaseBasketV2 = (basketId) => {
    return apiRequest({
        url: `${prefix}/v2/baskets/${basketId}/release`,
        method: 'POST'
    })
}

export const releaseBasket = (basketId) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}/release`,
        method: 'POST'
    })
}

export const exportListBaskets = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/search/csv`,
        method: 'POST',
        data: payload
    })
}

export const releaseBasketByOrders = (args) => {
    return apiRequest({
        url: `${prefix}/baskets/release-by-orders`,
        method: 'POST',
        data: args
    })
}

export const getBasketUncomplete = (params, cancelToken) => {
    return apiRequest({
        url: `${prefix}/data-exports/uncompleted-items`,
        method: 'GET',
        params,
        cancelToken
    })
}

export const exportListBasketsUncompleted = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/export/item-uncompleted`,
        method: 'POST',
        data: payload
    })
}

export const basketItemHistory = (data) => {
    return apiRequest({
        url: `${prefix}/set-basket-item-history/search`,
        method: 'POST',
        data
    })
}

export const countDuplicateBasket = () => {
    return apiRequest({
        url: `${prefix}/baskets/duplicate/count`,
        method: 'GET'
    })
}

export const getListDuplicateBaskets = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/duplicate/list`,
        method:'GET',
        params: payload,
    })
}

export const deleteDuplicateBasket = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/duplicate/delete`,
        method: 'POST',
        data: payload,
    })
}
